import type { StateCreator } from 'zustand';

export interface UISlice {
  settingsOpen: boolean;
  editingCourseId: string | null;
  expandedCourseIds: string[];
  activeTab: string;
  /** Whether the "Load Demo" header nav link is visible (default: enabled). */
  showLoadDemo: boolean;
  /** Whether the dataset picker is open. */
  demoPickerOpen: boolean;
  /** Transient Target GPA seeded by a "Set as target" action; cleared once consumed. */
  pendingTargetGPA: number | null;
  /** Transient nested scenario tab to activate; cleared once consumed. */
  pendingScenarioTab: 'target' | null;
  toggleSettings: () => void;
  setEditingCourse: (id: string | null) => void;
  toggleCourseExpanded: (id: string) => void;
  setActiveTab: (tab: string) => void;
  setShowLoadDemo: (visible: boolean) => void;
  setDemoPickerOpen: (open: boolean) => void;
  setPendingTargetGPA: (value: number) => void;
  clearPendingTargetGPA: () => void;
  setPendingScenarioTab: (tab: 'target') => void;
  clearPendingScenarioTab: () => void;
}

export const createUISlice: StateCreator<UISlice> = (set) => ({
  settingsOpen: false,
  editingCourseId: null,
  expandedCourseIds: [],
  activeTab: 'overview',
  showLoadDemo: true,
  demoPickerOpen: false,
  pendingTargetGPA: null,
  pendingScenarioTab: null,
  toggleSettings: () => set((state) => ({ settingsOpen: !state.settingsOpen })),
  setEditingCourse: (id) => set({ editingCourseId: id }),
  toggleCourseExpanded: (id) =>
    set((state) => ({
      expandedCourseIds: state.expandedCourseIds.includes(id)
        ? state.expandedCourseIds.filter((i) => i !== id)
        : [...state.expandedCourseIds, id],
    })),
  setActiveTab: (tab) => set({ activeTab: tab }),
  setShowLoadDemo: (visible) => set({ showLoadDemo: visible }),
  setDemoPickerOpen: (open) => set({ demoPickerOpen: open }),
  setPendingTargetGPA: (value) => set({ pendingTargetGPA: value }),
  clearPendingTargetGPA: () => set({ pendingTargetGPA: null }),
  setPendingScenarioTab: (tab) => set({ pendingScenarioTab: tab }),
  clearPendingScenarioTab: () => set({ pendingScenarioTab: null }),
});
